import axios, { client2 } from "@/config/axios-wrapper";
import { Chat } from "@/types/chat";

export const getJobMeetings = async (jobSeekerId, jobId, headers) => {
  return await axios.get(`/jobseekers/${jobSeekerId}/meetings?job_id=${jobId}`, { headers });
};

export const readChat = async (chatId: string) => {
  const response = await axios.post(`/chats/${chatId}/read`);
  return response.data;
};

export const getOrganizationChats = async (
  data: { organizationId: string; q: string },
  { skip, limit = 20 }: { skip: number; limit?: number },
) => {
  const response = await axios.get(
    `${`organizations/${data.organizationId}`}/chats?skip=${skip}&limit=${limit}&q=${data.q}`,
  );

  return response.data;
};

export const getUserChats = async (
  data: { userId: string; q: string },
  { skip, limit = 20 }: { skip: number; limit?: number },
) => {
  const response = await axios.get(
    `${`users/${data.userId}`}/chats?skip=${skip}&limit=${limit}&q=${data.q}`,
  );

  return response.data;
};

export const getChatByJobAndJobseekerId = async (data: {
  jobseeker_id: string;
  job_id: string;
}) => {
  const response = await axios.get<{ chats: Chat[] }>(
    `chats?jobseeker_id=${data.jobseeker_id}&job_id=${data.job_id}`,
  );
  if (response.data.chats.length === 0) {
    return null;
  }

  return response.data.chats[0];
};

export const getChatById = async ({ chatId }: { chatId: string }) => {
  const response = await axios.get<Chat>(`/chats/${chatId}`);
  return response.data;
};

export const getMessagesByChatId = async ({ chatId, limit = 20, dir = "before", cursor }) => {
  try {
    const queryParams = new URLSearchParams({
      limit: limit.toString(),
      dir,
      ...(cursor ? { cursor } : {}),
    });

    const response = await client2.get(`/chats/${chatId}/messages?${queryParams.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching messages:", error);
    throw new Error("Failed to fetch messages. Please try again.");
  }
};

export const getLocatedMessagesByMessageId = async ({
  chat_id,
  message_id,
}: {
  chat_id: string;
  message_id: string;
}) => {
  const response = await client2.post(`/chats/locateMessages`, {
    chat_id,
    message_id,
  });
  return response.data;
};
export const endChat = async ({ chatId }: { chatId: string }) => {
  const response = await axios.post(`/chats/${chatId}/end`);
  return response.data;
};

export const updateEndedChat = async ({
  chatId,
  data,
}: {
  chatId: string;
  data: { ended: boolean };
}) => {
  const response = await axios.put(`/chats/${chatId}/end`, data);
  return response.data;
};

export const getChatAcceptOfferById = async (jobId: string, offerId: string) => {
  const response = await axios.post(`/jobs/${jobId}/offer/${offerId}/accept`);
  return response.data;
};

export const getChatDeclineOfferById = async (jobId: string, offerId: string) => {
  const response = await axios.post(`/jobs/${jobId}/offer/${offerId}/decline`);
  return response.data;
};

export const getChatAcceptMeetingById = async (organizationId: string, meetingId: string) => {
  const response = await axios.post(
    `/organizations/${organizationId}/meetings/${meetingId}/accept`,
  );
  return response.data;
};

export const getChatDeclineMeetingById = async (organizationId: string, meetingId: string) => {
  const response = await axios.post(
    `/organizations/${organizationId}/meetings/${meetingId}/reject`,
  );
  return response.data;
};

export const createJobOfferByJobId = async (jobId: string, offer: any) => {
  const response = await axios.post(`/jobs/${jobId}/offer`, offer);
  return response.data;
};

export const updateJobOfferByJobId = async (jobId: string, offer: any) => {
  const response = await axios.post(`/jobs/${jobId}/offer/${offer.id}`, offer);
  return response.data;
};
